var _defs, _g, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #62797e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.4,92.5V10.8c0-1.9,1.5-3.4,3.4-3.4h48.7c1.9,0,3.4,1.5,3.4,3.4v81.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "39.8 92.5 39.8 70.4 62.8 70.4 62.8 92.6 51.3 92.6 51.3 70.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 35.7,
    y1: 19.6,
    x2: 35.7,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50,
    y1: 19.6,
    x2: 50,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.3,
    y1: 19.6,
    x2: 64.3,
    y2: 25.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 35.7,
    y1: 34.8,
    x2: 35.7,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50,
    y1: 34.8,
    x2: 50,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.3,
    y1: 34.8,
    x2: 64.3,
    y2: 41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 35.7,
    y1: 50,
    x2: 35.7,
    y2: 56.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50,
    y1: 50,
    x2: 50,
    y2: 56.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.3,
    y1: 50,
    x2: 64.3,
    y2: 56.2
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14,
    y1: 92.6,
    x2: 86,
    y2: 92.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.38845e39dd5a47463844f68d46b3037f.svg";
export { ForwardRef as ReactComponent };